import $ from "jquery";
/* eslint-disable */
export default function maps() {
  var map = L.map("map-container", {
    center: [51.641757, -54.803722],
    zoom: 3,
    zoomControl: false,
    attributionControl: false,
    scrollWheelZoom: false,
    draggable: false,
  });

  L.tileLayer(
    "https://api.mapbox.com/styles/v1/brightbyte/ckhknb3gz5hx819o0vw8nxl5l/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiYnJpZ2h0Ynl0ZSIsImEiOiJjaWs2czNvMWIwMDVod2lrc3l1Y2lzb2NzIn0.Gmfb_iCHibA2mnYsQrM7aw",
    {
      id: "brightbyte/ckhknb3gz5hx819o0vw8nxl5l",
      accessToken:
        "pk.eyJ1IjoiYnJpZ2h0Ynl0ZSIsImEiOiJjaWs2czNvMWIwMDVod2lrc3l1Y2lzb2NzIn0.Gmfb_iCHibA2mnYsQrM7aw",
      draggable: false,
    }
  ).addTo(map);

  var templateUrl = object_name.templateUrl;

  var mapIcon = L.icon({
    iconUrl: "" + templateUrl + "/assets/images/marker.png",
    iconSize: [52, 52], // size of the icon
    iconAnchor: [26, 26], // point of the icon which will correspond to marker's location
    popupAnchor: [0, 0], // point from which the popup should open relative to the iconAnchor
  });

  $(".map-pins .map-pin").each(function (index) {
    var lat = $(this).attr("data-lat");
    var lng = $(this).attr("data-lng");
    var name = $(this).attr("data-name");
    L.marker([lat, lng], { icon: mapIcon }).addTo(map).bindPopup(name);
  });
}
